import { TemaCard } from "../models/TemaCardModel";

export const legalCards: TemaCard[] = [
    // 📝 Visas & Residency
    new TemaCard(
        'legal1',
        'Legal',
        'sentence',
        '¿Cómo puedo solicitar una visa de trabajo?',
        'How can I apply for a work visa?',
        'Useful for immigration offices or lawyers.'
    ),
    new TemaCard(
        'legal2',
        'Legal',
        'sentence',
        '¿Cuánto tiempo tarda en procesarse mi solicitud?',
        'How long does it take to process my application?',
        'Great to ask at immigration or consulate.'
    ),
    new TemaCard(
        'legal3',
        'Legal',
        'phrase',
        'Necesito renovar mi visa de residencia.',
        'I need to renew my residence visa.',
        'Used when visiting immigration offices for renewal.'
    ),
    new TemaCard(
        'legal4',
        'Legal',
        'word',
        'residencia',
        'residence',
        'Used in the context of residency paperwork.',
        [
            { spanish: 'permiso de trabajo', english: 'work permit' },
            { spanish: 'visa de estudiante', english: 'student visa' },
            { spanish: 'residencia permanente', english: 'permanent residency' },
        ]
    ),

    // 🔐 Legal Emergencies & Rights
    new TemaCard(
        'legal21',
        'Legal',
        'sentence',
        'Necesito hablar con un abogado, por favor.',
        'I need to speak with a lawyer, please.',
        'Say this if you’re in legal trouble.'
    ),

    new TemaCard(
        'legal23',
        'Legal',
        'sentence',
        '¿Tengo derecho a un intérprete?',
        'Do I have the right to an interpreter?',
        'Important in legal or police settings.'
    ),

    // 🏢 Dealing with Officials & Appointments
    new TemaCard(
        'legal7',
        'Legal',
        'sentence',
        '¿Dónde está la oficina de inmigración?',
        'Where is the immigration office?',
        'A good question when dealing with bureaucratic institutions.'
    ),
    new TemaCard(
        'legal8',
        'Legal',
        'sentence',
        '¿Cómo puedo hacer una cita con el notario?',
        'How can I make an appointment with the notary?',
        'Use this when needing legal notarization.'
    ),

    new TemaCard(
        'legal10',
        'Legal',
        'sentence',
        '¿Puedo obtener una traducción jurada de este documento?',
        'Can I get a sworn translation of this document?',
        'Important for legal documents when moving abroad.'
    ),

    // 📄 Legal Documents & IDs
    new TemaCard(
        'legal5',
        'Legal',
        'sentence',
        '¿Dónde puedo obtener una copia de mi acta de nacimiento?',
        'Where can I get a copy of my birth certificate?',
        'Used for any official documentation requests.'
    ),
    new TemaCard(
        'legal6',
        'Legal',
        'word',
        'documento de identidad',
        'identity document',
        'General term for official IDs in many countries.',
        [
            { spanish: 'pasaporte', english: 'passport' },
            { spanish: 'DNI', english: 'ID card' },
            { spanish: 'licencia de conducir', english: 'driver’s license' },
        ]
    ),

    // ⚖️ Contracts & Agreements
    new TemaCard(
        'legal11',
        'Legal',
        'sentence',
        '¿Puedo revisar el contrato antes de firmarlo?',
        'Can I review the contract before signing it?',
        'Always ask before signing anything important.'
    ),
    new TemaCard(
        'legal12',
        'Legal',
        'sentence',
        'Este contrato está en español, ¿puedo obtenerlo en inglés?',
        'This contract is in Spanish, can I get it in English?',
        'Useful when dealing with foreign language documents.'
    ),

    // 🧾 Notarization & Legalization
    new TemaCard(
        'legal14',
        'Legal',
        'sentence',
        'Este documento necesita ser legalizado.',
        'This document needs to be legalized.',
        'Key phrase for making documents official.'
    ),
    new TemaCard(
        'legal15',
        'Legal',
        'phrase',
        '¿Dónde puedo obtener una apostilla?',
        'Where can I get an apostille?',
        'Use this for international document legalization.'
    ),

    // 🏛 Lawyer & Court
    new TemaCard(
        'legal16',
        'Legal',
        'sentence',
        'Tengo una consulta con el abogado el lunes.',
        'I have a consultation with the lawyer on Monday.',
        'Phrase to confirm an appointment.'
    ),
    new TemaCard(
        'legal17',
        'Legal',
        'word',
        'abogado',
        'lawyer',
        'General term for a lawyer.',
        [
            { spanish: 'abogado defensor', english: 'defense lawyer' },
            { spanish: 'abogado de familia', english: 'family lawyer' },
            { spanish: 'abogado de inmigración', english: 'immigration lawyer' },
        ]
    ),
    new TemaCard(
        'legal18',
        'Legal',
        'sentence',
        '¿Qué debo llevar para mi audiencia en el tribunal?',
        'What should I bring for my court hearing?',
        'A common question for people in legal disputes.'
    ),

    // 📋 Bureaucracy & Applications
    new TemaCard(
        'legal19',
        'Legal',
        'sentence',
        '¿Cómo puedo completar esta solicitud en línea?',
        'How can I fill out this application online?',
        'Use this when dealing with online forms or registration.'
    ),
    new TemaCard(
        'legal20',
        'Legal',
        'sentence',
        'Necesito presentar estos documentos antes del viernes.',
        'I need to submit these documents before Friday.',
        'Typical deadline phrase for bureaucratic processes.'
    ),
    new TemaCard(
        'legal24',
        'Legal',
        'phrase',
        'Este formulario está en español, ¿puede ayudarme a llenarlo?',
        'This form is in Spanish, can you help me fill it out?',
        'For dealing with tricky paperwork.'
    ),

    // 🚔 Reporting Issues or Fines

    new TemaCard(
        'legal26',
        'Legal',
        'phrase',
        'Recibí una multa, pero no entiendo por qué.',
        'I received a fine, but I don’t understand why.',
        'Used when dealing with traffic or administrative fines.'
    ),
];
